import { gql } from '@apollo/client'

export const HUK_COVERAGE_CHECK_QUERY = gql`
  query hukCoverageCheck($policyNumber: String!) {
    hukCoverageCheck(policyNumber: $policyNumber) {
      data {
        gdvKey
        langText
        versichert
      }
      text
    }
  }
`
